import { render, staticRenderFns } from "./MyJob.vue?vue&type=template&id=a27edaea&scoped=true"
import script from "./MyJob.vue?vue&type=script&lang=js"
export * from "./MyJob.vue?vue&type=script&lang=js"
import style0 from "./MyJob.vue?vue&type=style&index=0&id=a27edaea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27edaea",
  null
  
)

export default component.exports